export default function getMobileNoInfoReducer(state = { mobileNoInfoState: [] }, action) {
    switch (action.type) {
        case 'MOBILENO_INFO':
            return {
                mobileNoInfoState: action.mobileNoInfoState
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/getmobilenoinfo.jsx